export default "__VITE_ASSET__C_xG3wWj__"